// extracted by mini-css-extract-plugin
export default {"container":"PortalPortlet__container--3RX","describe":"PortalPortlet__describe--1CG","describeText":"PortalPortlet__describeText--2u9"};